(function () {
  function init(wrap) {
    if (!wrap || wrap.getAttribute('data-hm-ready')) return;
    wrap.setAttribute('data-hm-ready', '1');
    var video = wrap.querySelector('video');
    if (!video) return;
    var btn = wrap.querySelector('[data-hm-toggle]');
    var label = btn ? btn.querySelector('.hm-video__toggle-text') : null;
    var small = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    var mobileMode = wrap.getAttribute('data-mobile') || 'play';
    if (small && mobileMode !== 'play') return; /* "show image instead" / "hide" on mobile: never load the video */

    var controls = wrap.getAttribute('data-controls') === '1';
    var loaded = !!video.getAttribute('src');

    function setLabel(playing) {
      if (!btn) return;
      var text = playing ? btn.getAttribute('data-label-pause') : btn.getAttribute('data-label-play');
      btn.setAttribute('aria-label', text);
      if (label) label.textContent = playing ? btn.getAttribute('data-text-pause') : btn.getAttribute('data-text-play');
    }
    function setSrc() {
      if (loaded) return;
      loaded = true;
      var useSmall = small && video.getAttribute('data-src-small');
      video.src = useSmall ? video.getAttribute('data-src-small') : video.getAttribute('data-src');
      video.load();
    }
    function play() {
      setSrc();
      var p = video.play();
      if (p && p.catch) p.catch(function () { setLabel(false); });
    }

    video.addEventListener('play', function () { setLabel(true); });
    video.addEventListener('pause', function () { setLabel(false); });
    if (btn) {
      btn.addEventListener('click', function () {
        if (video.paused) { play(); } else { video.pause(); }
      });
    }
    setLabel(!video.paused);

    /* Native autoplay (muted videos) already started via the HTML autoplay attribute.
       We still pause when scrolled far off-screen (saves bandwidth/battery) and resume
       when it comes back, and lazily load+play on first intersection for the
       non-autoplay / controls case. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (video.getAttribute('data-autoplay') === '1' && video.paused && !video.ended) { play(); }
          } else if (loaded && !video.paused) {
            video.pause();
          }
        });
      }, { threshold: 0.1 });
      io.observe(wrap);
    }
  }
  function initAll() {
    var nodes = document.querySelectorAll('[data-hm-video]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();